import { createSlice } from "@reduxjs/toolkit";
import type { MaybeType } from "@/shared/types";
import type { ContactGroupFilter } from "@/entities/contacts-filters/model";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { ContactsState } from "../types";

const initialState: ContactsState = {
  filter: null,
  selectedPersonId: null,
};

export const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    setGroupFilter: (state, action: PayloadAction<ContactGroupFilter>) => {
      state.filter = action.payload;
    },
    clearGroupFilter: (state) => {
      state.filter = null;
    },
    setSelectedPersonId: (state, action: PayloadAction<MaybeType<string>>) => {
      state.selectedPersonId = action.payload;
    },
    clearSelectedPersonId: (state) => {
      state.selectedPersonId = null;
    },
  },
  selectors: {
    selectGroupFilter: (state) => state.filter,
    selectSelectedPersonId: (state) => state.selectedPersonId,
  },
});

export const {
  actions: contactsActions,
  reducer: contactsReducer,
  selectors: contactsSelectors,
} = contactsSlice;
